var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSkl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32586)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6641 4.77675V5.33419H5.51813V12.6658H12.6641V13.7812L8.49038 13.7492L4.29975 13.7014L4.25138 8.95219L4.21875 4.21875H12.6641V4.77675Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3301 6.1312C13.9635 6.3067 14.5159 6.80058 14.6942 7.35858C14.7915 7.69327 14.7431 7.72477 14.1744 7.72477C13.7357 7.72477 13.4927 7.62914 13.3464 7.40639C13.1029 7.00758 11.9981 6.95977 11.6736 7.34227C11.3164 7.77258 11.7062 8.09152 12.9729 8.37839C13.6063 8.52183 14.2723 8.76089 14.4506 8.92008C15.2629 9.63727 14.9377 11.2151 13.8825 11.6454C13.1681 11.9323 11.9981 11.9323 11.2837 11.6454C10.7966 11.4384 10.2279 10.7212 10.2279 10.2751C10.2279 9.98827 11.2838 10.0996 11.5599 10.4343C12.1449 11.088 13.5084 10.9923 13.6063 10.2909C13.6873 9.7492 13.3785 9.51014 12.4532 9.3982C10.9429 9.1912 10.3905 8.72883 10.3905 7.67695C10.3905 6.43383 11.7546 5.70089 13.3301 6.1312Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32586"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkl);
export default __webpack_public_path__ + "static/media/skl.d3d84fdfb866b9c664cb02d472c70f49.svg";
export { ForwardRef as ReactComponent };